module.exports = __webpack_public_path__ + "static/roboto-v20-cyrillic_latin-regular-c2bf54bc567401239fcc81b063df7423.woff";